


























































import {Component, Prop, Vue} from 'vue-property-decorator';
import {NotificationCategory, NotificationSummary} from '../../../build/swagger-code-extranet-api-definition';
import NotificationCenterStoreModule from '../../store/modules/notificationCenter.module';
import {
    NOTIFICATION_CENTER_OVERVIEW_BUS,
    TRIGGER_NOTIFICATION_BELL_ANIMATION,
} from '../../constants';
import {getModule} from 'vuex-module-decorators';

@Component
export default class NotificationCenterItem extends Vue {
    @Prop(Boolean) displayBudgetOrders: boolean;
    @Prop(Number) budgetOrdersCount: number;
    @Prop(String) budgetOrdersURL: string;
    @Prop(String) notificationsOverviewURL: string;
    @Prop(String) notificationsDetailBaseURL: string;
    @Prop(String) language: string;
    @Prop(String) country: string;

    store: NotificationCenterStoreModule = getModule(NotificationCenterStoreModule, this.$store);
    animateBell = false;
    backDropIsVisible = false;

    mounted() {
        const bus = window[NOTIFICATION_CENTER_OVERVIEW_BUS];
        if (bus) {
            bus.$on(TRIGGER_NOTIFICATION_BELL_ANIMATION, () => {
                this.animateBell = true;
                setTimeout(() => {
                    this.animateBell = false;
                }, 3000);
            });
        }
    }

    get budgetOrderMessage() {
        if (this.budgetOrdersCount === 1) {
            return this.$tc('notificationCenter.overviewWidget.numberOfBudgetOrdersSingular');
        } else if (this.budgetOrdersCount > 1) {
            return this.$tc('notificationCenter.overviewWidget.numberOfBudgetOrdersPlural', this.budgetOrdersCount);
        } else {
            return this.$tc('notificationCenter.overviewWidget.noBudgetOrders');
        }
    }

    get hasBudgetOrders(): boolean {
        return this.budgetOrdersCount > 0;
    }

    get hasUnreadNotifications(): boolean {
        return this.unreadNotificationsCount > 0;
    }

    get unreadNotificationsCount(): number {
        return this.store.notificationsSummary && this.store.notificationsSummary.totalCount
            ? this.store.notificationsSummary.totalCount : 0;
    }

    get hasUnreadAnything(): boolean {
        return this.hasUnreadNotifications || (this.displayBudgetOrders ? this.hasBudgetOrders : false);
    }

    get unreadAnythingCount(): number {
        return this.unreadNotificationsCount + (this.displayBudgetOrders ? this.budgetOrdersCount : 0);
    }

    get notificationsSummary(): NotificationSummary[] {
        return this.store.notificationsSummary ? this.store.notificationsSummary.notifications : [];
    }

    get remainingNotifications(): number {
        return this.unreadNotificationsCount - this.notificationsSummary.length;
    }

    getIconFromCategory(category: string): string {
        switch (category) {
            case NotificationCategory.MAINTENANCE.toString():
                return 'exclamation';
            case NotificationCategory.MARKETING.toString():
                return 'gift';
            case NotificationCategory.NEWFEATURE.toString():
                return 'wrench';
        }
    }

    getSanitizedShortText(notification: NotificationSummary) {
        return Vue.prototype.$sanitize(notification.shortText);
    }

    urlWithLocale(url: string) {
        if (this.language && this.country) {
            return url + `?locale=${this.language}-${this.country}`;
        } else if (this.language) {
            return url + `?locale=${this.language}`;
        } else {
            return url;
        }
    }

    showBackDrop() {
        this.backDropIsVisible = true;
    }
    hideBackDrop() {
        this.backDropIsVisible = false;
    }
}
